// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qf-9";
export var arrowButtonContainer = "_qf-5";
export var arrowButtonIcon = "_qf-6";
export var carouselArrowButton = "_qf-2";
export var carouselElementContainer = "_qf-1";
export var currentSlide = "_qf-8";
export var left = "_qf-3";
export var otherSlide = "_qf-a";
export var productCarouselContainer = "_qf-0";
export var right = "_qf-4";
export var sliderOverflow = "_qf-7";